import { PrinterStatusDto } from './printer-status.dto';

export class PrinterStatus {
    readonly reachable: boolean;
    readonly mediaStatus: string | null;
    readonly headLatch: string | null;
    readonly paperOk: boolean;
    readonly headClosed: boolean;
    readonly widthDots: number | null;
    readonly lengthDots: number | null;

    constructor(dto: PrinterStatusDto) {
        this.reachable = dto.reachable;
        this.mediaStatus = dto.mediaStatus;
        this.headLatch = dto.headLatch;
        this.paperOk = dto.paperOk;
        this.headClosed = dto.headClosed;
        this.widthDots = dto.widthDots;
        this.lengthDots = dto.lengthDots;
    }
}
